import React from 'react';
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import { EXTERNAL_LINKS} from '../../constants/links';

import KakaoLoginButton from "../../components/auth/KakaoLoginButton";
import GoogleLoginButton from "../../components/auth/GoogleLoginButton";
import EmailLoginButton from "../../components/auth/EmailLoginButton";
import DeviceScreenLayout from '../../components/layouts/DeviceScreenLayout';

// import LogoImage from "../../assets/logo/OOFIT-LOGO-2.png";




const AuthLoginPage = () => {
    const navigate = useNavigate()
    const serviceName = process.env.REACT_APP_NAME || "서비스"; // 기본값 설정 권장

    return (
        <DeviceScreenLayout>
            <BackgroundLayout>


                <LoginViewWrapper>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div
                            onClick={()=> {
                                navigate("/")
                            }}
                            style={{
                                // width: '140px',
                                // aspectRatio: "314/78",
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            {/* <img src={LogoImage} 
                                style={{
                                    width: '100%',
                                    objectFit: 'cover',
                                }}
                            /> */}

                            <span
                                style={{
                                    fontSize: '24px',
                                    fontFamily: "Pretendard",
                                    fontWeight: 700
                                }}
                            >
                                DDIRING
                            </span>

                        </div>
                    </div>

                    <div
                        style={{
                            marginTop: '36px',
                            gap: '16px',
                            display: 'flex',
                            flexDirection: 'column'

                        }}
                    >
                        <KakaoLoginButton eventHandler={()=>{
                            navigate("/auth/register")
                        }}/>
                        <GoogleLoginButton eventHandler={()=>{
                            navigate("/auth/register")
                        }}/>
                        <EmailLoginButton onClick={()=>{
                            navigate("/auth/login/email")
                        }}/>
                    </div>

                    <div
                        style={{
                            marginTop: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <span
                            style={{
                                color: '#999999',
                                fontSize: '12px',
                                fontFamily: "Pretendard",
                                textAlign: 'center',
                                lineHeight: '160%',
                            }}
                        >
                            계정을 만들면&nbsp;                            
                            <span
                                style={{
                                    color: '#232323',
                                }}
                            >
                                {serviceName}
                            </span>의&nbsp;
                            <span
                                onClick={() => window.open(EXTERNAL_LINKS.TERMS, '_blank', 'noopener,noreferrer')}
                                style={{
                                    color: '#676767',
                                    fontSize: '12px',
                                    fontFamily: "Pretendard",
                                    textDecoration: 'underline',
                                    cursor: 'pointer'
                                    
                                }}
                            >
                                서비스 이용약관
                            </span>
                            &nbsp;및&nbsp;
                            <span
                                onClick={() => window.open(EXTERNAL_LINKS.PRIVACY, '_blank', 'noopener,noreferrer')}
                                style={{
                                    color: '#676767',
                                    fontSize: '12px',
                                    fontFamily: "Pretendard",
                                    textDecoration: 'underline',
                                    cursor: 'pointer'
                                }}
                            >
                                개인정보처리방침
                            </span>
                            에 동의하게 됩니다.
                        </span>

                    </div>
                </LoginViewWrapper>
            </BackgroundLayout>
        </DeviceScreenLayout>
    )
}



const LoginViewWrapper = styled.div`
    /* [기본 설정] 1920px 이상 (초대형 모니터) */
    width: 480px;
    padding: 40px;
    // border-radius: 16px;
    // border: 1px solid #E5E8EB;
    // box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: stretch;


    /* [Laptop] 1366px 이하 */
    @media ${({ theme }) => theme.laptop} {

    }

    /* [Pad/Tablet] 768px 이하 */
    @media ${({ theme }) => theme.tablet} {
        padding: 0px;
        box-shadow: none;
        border: none;
        width: 100%;
    }

    /* [Mobile] 375px 이하 */
    @media ${({ theme }) => theme.mobile} {

    }
`



const BackgroundLayout = styled.div`
    /* [기본 설정] 1920px 이상 (초대형 모니터) */
    flex: 1;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;


    /* [Laptop] 1366px 이하 */
    @media ${({ theme }) => theme.laptop} {
        flex: 1;
        background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* [Pad/Tablet] 768px 이하 */
    @media ${({ theme }) => theme.tablet} {
        flex: 1;
        background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px;
    }

    /* [Mobile] 375px 이하 */
    @media ${({ theme }) => theme.mobile} {
        flex: 1;
        background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
   
      
    }
`

export default AuthLoginPage;